import LabelFree from './LabelFree'

export default LabelFree
// eslint-disable-next-line import/export
export * from './LabelFree'
